import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import renderSelectField from "../../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../../shared/components/form/MultiSelect";
import { Field, reduxForm } from "redux-form";
import { withTranslation } from "react-i18next";
import { Card, CardBody, Col, Nav, NavItem, NavLink, TabContent, TabPane, Row } from 'reactstrap';
import classnames from 'classnames';
import { withStyles } from "@material-ui/core/styles";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import Pathologicals from './Pathologicals';
import Surgicals from './Surgicals';
import Pharmacological from './Pharmacological';
import Gynecologists from "./Gynecologists";
import SectionAilment from '../Background/components/SectionAilment';
import Habits from './Habits';
//import HabitsOld from '../Background/components/Habits';
import Family from './Family';
import Other from './Other';
import Inmunizations from './Inmunizations';

const MedicalRadio = withStyles({
    root: {
        color: '#4CE1B6',
        '&$checked': {
            color: '#4CE1B6',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);

class PatientBackground extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: '1',
            width: window.innerWidth,
            height: window.innerHeight
        }
    }

    toggle = (tab) => {
        const { activeTab } = this.state;
        if (activeTab !== tab) {
            this.setState({
                activeTab: tab,
            });
        }
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight }, () => console.log("ANCHO: ", this.state.width, "ALTO: ", this.state.height));
    }


    render() {
        const { activeTab, height, width } = this.state;

        return (
            <Fragment>
                <div className={"container-wraper-hc"}>
                    <div className="tabs tabs--bordered-top" style={{ overflow: 'hidden' }}>
                        <div className="tabs__wrap">
                            <Col>
                                <Nav tabs className="nav-tabs-results-procedures" style={{ width: '100%' }}>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '1' })}
                                            onClick={() => {
                                                this.toggle('1');
                                            }}
                                        >
                                            Patologicos
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '2' })}
                                            onClick={() => {
                                                this.toggle('2');
                                            }}
                                        >
                                            Quirurgicos
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '3' })}
                                            onClick={() => {
                                                this.toggle('3');
                                            }}
                                        >
                                            Farmacologicos
                                        </NavLink>
                                    </NavItem>
                                    {this.props.gender === "Femenino" ?
                                        <NavItem>
                                            <NavLink
                                                className={classnames({ active: activeTab === '4' })}
                                                onClick={() => {
                                                    this.toggle('4');
                                                }}
                                            >
                                                Ginecobstétricos
                                            </NavLink>
                                        </NavItem>
                                        : null}
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '8' })}
                                            onClick={() => {
                                                this.toggle('8');
                                            }}
                                        >
                                            Familiares
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '7' })}
                                            onClick={() => {
                                                this.toggle('7');
                                            }}
                                        >
                                            Otros
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '5' })}
                                            onClick={() => {
                                                this.toggle('5');
                                            }}
                                        >
                                            Inmunizaciones
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            className={classnames({ active: activeTab === '6' })}
                                            onClick={() => {
                                                this.toggle('6');
                                            }}
                                        >
                                            Hábitos
                                        </NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                            <Col>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1" style={{ padding: 0 }}>
                                        <Pathologicals
                                            stateClinicHistory={this.props.stateClinicHistory}
                                            sectionAilment={this.props.sectionAilment}
                                            handlerPathologicalBackgroundRadio={this.props.handlerPathologicalBackgroundRadio}
                                            handlerPathologicalBackgroundText={this.props.handlerPathologicalBackgroundText}
                                            handlerPathologicsObservation={this.props.handlerPathologicsObservation}
                                            id_historia={this.props.id_historia}
                                            handlerOthersBackgroundRadio={this.props.handlerOthersBackgroundRadio}
                                            handlerOthersBackgroundText={this.props.handlerOthersBackgroundText}
                                            handlerOthersBackgroundObservation={this.props.handlerOthersBackgroundObservation}
                                        />
                                    </TabPane>
                                    <TabPane tabId="2" style={{ padding: 0 }}>
                                        <Surgicals
                                            stateClinicHistory={this.props.stateClinicHistory}
                                            sectionAilment={this.props.sectionAilment}
                                            handlerSurgicalsBackgroundRadio={this.props.handlerSurgicalsBackgroundRadio}
                                            handlerSurgicalsBackgroundText={this.props.handlerSurgicalsBackgroundText}
                                            handlerSurgicalsBackgroundObservation={this.props.handlerSurgicalsBackgroundObservation}
                                        />
                                    </TabPane>
                                    <TabPane tabId="3" style={{ padding: 0 }}>
                                        <Pharmacological
                                            stateClinicHistory={this.props.stateClinicHistory}
                                            sectionAilment={this.props.sectionAilment}
                                            handlerPharmacologicalBackgroundRadio={this.props.handlerPharmacologicalBackgroundRadio}
                                            handlerPharmacologicalBackgroundText={this.props.handlerPharmacologicalBackgroundText}
                                            handlerPharmacologicalBackgroundTableAdd={this.props.handlerPharmacologicalBackgroundTableAdd}
                                            handlerPharmacologicalBackgroundTableDelete={this.props.handlerPharmacologicalBackgroundTableDelete}
                                            handlerPharmacologicalBackgroundObservation={this.props.handlerPharmacologicalBackgroundObservation}
                                            searchMedicaments={this.props.searchMedicaments}
                                            handlerFormulasNewFunctional={this.props.handlerFormulasNewFunctional}
                                            id_historia={this.props.id_historia}
                                        />
                                    </TabPane>
                                    <TabPane tabId="4" style={{ padding: 0 }}>
                                        <Gynecologists
                                            stateClinicHistory={this.props.stateClinicHistory}
                                            sectionAilment={this.props.sectionAilment}
                                            handlerGynecologistBackgroundRadio={this.props.handlerGynecologistBackgroundRadio}
                                            handlerGynecologistBackgroundText={this.props.handlerGynecologistBackgroundText}
                                            handlerGynecologistBackgroundObservation={this.props.handlerGynecologistBackgroundObservation}
                                        />
                                    </TabPane>
                                    <TabPane tabId="5" style={{ padding: 0 }}>
                                        <Inmunizations
                                            stateClinicHistory={this.props.stateClinicHistory}
                                            sectionAilment={this.props.sectionAilment}
                                            handlerInmunizationsBackgroundRadio={this.props.handlerInmunizationsBackgroundRadio}
                                            handlerInmunizationsBackgroundText={this.props.handlerInmunizationsBackgroundText}
                                            handlerInmunizationsBackgroundTableAdd={this.props.handlerInmunizationsBackgroundTableAdd}
                                            handlerInmunizationsBackgroundTableDelete={this.props.handlerInmunizationsBackgroundTableDelete}
                                            handlerInmunizationsBackgroundObservation={this.props.handlerInmunizationsBackgroundObservation}
                                        />
                                    </TabPane>
                                    <TabPane tabId="6" style={{ padding: 0 }}>
                                        <Habits
                                            stateClinicHistory={this.props.stateClinicHistory}
                                            sectionAilment={this.props.sectionAilment}
                                            handlerHabits={this.props.handlerHabits}
                                            calculateSmoke={this.props.calculateSmoke}
                                            dataPatient={this.props.dataPatient}
                                        />
                                    </TabPane>
                                    <TabPane tabId="7" style={{ padding: 0 }}>
                                        <Other
                                            stateClinicHistory={this.props.stateClinicHistory}
                                            sectionAilment={this.props.sectionAilment}
                                            handlerOthersBackgroundRadio={this.props.handlerOthersBackgroundRadio}
                                            handlerOthersBackgroundText={this.props.handlerOthersBackgroundText}
                                            handlerOthersBackgroundObservation={this.props.handlerOthersBackgroundObservation}
                                            id_historia={this.props.id_historia}
                                            handlerChangeColorAlergies={this.props.handlerChangeColorAlergies}    
                                        />
                                    </TabPane>
                                    <TabPane tabId="8" style={{ padding: 0 }}>
                                        <Family
                                            stateClinicHistory={this.props.stateClinicHistory}
                                            sectionAilment={this.props.sectionAilment}
                                            handlerFamilyBackgroundRadio={this.props.handlerFamilyBackgroundRadio}
                                            handlerFamilyBackgroundText={this.props.handlerFamilyBackgroundText}
                                            handlerFamilyBackgroundObservation={this.props.handlerFamilyBackgroundObservation}
                                        />
                                    </TabPane>
                                </TabContent>
                            </Col>
                        </div>
                    </div>
                </div>
            </Fragment >
        );
    }
}

export default reduxForm({
    form: "patient-background",
})(withTranslation("common")(PatientBackground));
